import axios from "axios";

export default {
  namespaced: true,
  state: {
    image: null,
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    imagesMessage: ''
  },
  mutations: {
    DO_NOTHING(state) {
      state.isReceiving = false;
    },
    RECEIVED_IMAGES(state, payload) {
      state.images = payload;
      state.isReceiving = false;
    },
    RECEIVED_IMAGE(state, payload) {
      state.image = payload;
      state.isReceiving = false;
    },
    RECEIVING_IMAGES(state) {
      state.isReceiving = true;
    },
    RECEIVING_IMAGE(state) {
      state.isReceiving = true;
    },
    UPDATED_IMAGE(state, payload) {
      let index = state.images.findIndex(i=>i._id==payload._id);
      state = Object.assign(state, {
        images: state.images.map((image, i) => {
          if (i === index) {
            return Object.assign({}, image, payload);
          }
          return image;
        }),
        isReceiving: false,
        imagesMessage: 'Images has been updating!',
      })
    },
    UPDATING_IMAGE(state) {
      state.isReceiving = true;
    },
    DELETED_IMAGE(state, payload) {
      let indexToDelete = state.images.findIndex(image => image._id === payload._id);
      let images = [...state.images];
      images.splice(indexToDelete, 1);
      state = Object.assign(state, {
        images: [...images],
        isDeleting: false,
        idToDelete: null,
        imagesMessage: 'Image has been Deleted!',
      });
    },
    DELETING_IMAGE(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async deleteImageRequest({dispatch}, payload) {
      try{
        dispatch("updatingImage");
        let token = localStorage.getItem("token");
        let url ="https://api.tradexc.com:3000/delete/image/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("doNothing");
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertImageRequest({dispatch}, payload) {
      try{
        if(payload.imagefile == undefined || payload.imagefile == null) return;
        dispatch("receivingImages");
        let token = localStorage.getItem('token');
        let url = `https://api.tradexc.com:3000/insert/image/${payload.route}/${payload.id}`;
        
        let data = new FormData();
        data.append('image', payload.imagefile); 
        delete payload['id'];
        delete payload['imagefile'];
        for (let x in payload) data.append(x, payload[x]);
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let response = await axios({method: "POST", url: url, headers: headers, data: data});
        dispatch("receiveImage", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateImageRequest({dispatch}, payload) {
      dispatch("updatingImage");
      let id = payload.id;
      delete payload['id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/image/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      let response = await axios({method: "put", url: url, headers: headers, data: payload});
      dispatch("updateImage", response.data);
      return response.data;
    },
    async updateImageWithImageRequest({dispatch}, payload) {
      try{
        dispatch("updatingImage");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/image/withimage/' + payload.id;

        let data = new FormData();  
        data.append('file', payload.imagefile, payload.imagename); 
        delete payload['imagefile'];
        for (let x in payload) data.append(x, payload[x]);

        let response = await axios({method: "PUT", url: url, headers: headers, data: data});
        dispatch("updateImage", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getDownloadImage({dispatch}, url){
      dispatch("updatingImage");
      const response = await fetch(url);
      let data = await response.blob();
      let blob = new Blob([data], { type: 'application/pdf' });
      let imagesrc = URL.createObjectURL(blob);
      return imagesrc;
    },
    doNothing({commit}) {
      commit("DO_NOTHING")
    },
    receivedImages({commit}, payload) {
      commit("RECEIVED_IMAGES", payload)
    },
    receivingImages({commit}) {
      commit("RECEIVING_IMAGES")
    },
    receiveImage({commit}, payload) {
      commit("RECEIVED_IMAGE", payload)
    },
    receivingImage({commit}) {
      commit("RECEIVING_IMAGE")
    },
    updateImage({commit}, payload) {
      commit("UPDATED_IMAGE", payload)
    },
    updatingImage({commit}) {
      commit("UPDATING_IMAGE")
    },
    deleteImage({commit}, payload) {
      commit("DELETED_IMAGE", payload)
    },
    deletingImage({commit}, payload) {
      commit("DELETING_IMAGE", payload)
    }
  },
};
